export const getDeviceName = (rack: number) => `HD_USB_CAM_${rack}`;
